
import Room from 'src/modules/room';

const RoomPage = () => {
  return <Room />;
};

export default RoomPage;
